'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

require('../stylesheets/nps-modal.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getScoreRange = function getScoreRange(maxScore) {
    return Array.from({ length: maxScore }, function (_, i) {
        return i + 1;
    });
};

_reactModal2.default.setAppElement('body');

var NPSModal = function NPSModal(props) {
    var detractorFollowUpQuestion = props.detractorFollowUpQuestion,
        detractorUpperBound = props.detractorUpperBound,
        header = props.header,
        mainQuestion = props.mainQuestion,
        maxScore = props.maxScore,
        maxScoreBlurb = props.maxScoreBlurb,
        minScoreBlurb = props.minScoreBlurb,
        modalClassName = props.modalClassName,
        modalClassPrefix = props.modalClassPrefix,
        neutralFollowUpQuestion = props.neutralFollowUpQuestion,
        onCommentSubmit = props.onCommentSubmit,
        onScoreClick = props.onScoreClick,
        overlayClassName = props.overlayClassName,
        promoterFollowUpQuestion = props.promoterFollowUpQuestion,
        promoterLowerBound = props.promoterLowerBound;

    var _useState = (0, _react.useState)(getScoreRange(maxScore)),
        _useState2 = _slicedToArray(_useState, 2),
        scoreRange = _useState2[0],
        setScoreRange = _useState2[1];

    var _useState3 = (0, _react.useState)(true),
        _useState4 = _slicedToArray(_useState3, 2),
        visible = _useState4[0],
        setVisible = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        showFollowUp = _useState6[0],
        setShowFollowUp = _useState6[1];

    var _useState7 = (0, _react.useState)(),
        _useState8 = _slicedToArray(_useState7, 2),
        followUpQuestion = _useState8[0],
        setFollowUpQuestion = _useState8[1];

    var _useState9 = (0, _react.useState)(),
        _useState10 = _slicedToArray(_useState9, 2),
        score = _useState10[0],
        setScore = _useState10[1];

    var _useState11 = (0, _react.useState)(''),
        _useState12 = _slicedToArray(_useState11, 2),
        comment = _useState12[0],
        setComment = _useState12[1];

    var _useState13 = (0, _react.useState)(),
        _useState14 = _slicedToArray(_useState13, 2),
        contentRef = _useState14[0],
        setContentRef = _useState14[1];

    (0, _react.useEffect)(function () {
        setScoreRange(getScoreRange(maxScore));
    }, [maxScore]);

    (0, _react.useEffect)(function () {
        if (score <= detractorUpperBound) {
            setFollowUpQuestion(detractorFollowUpQuestion);
        } else if (score < promoterLowerBound) {
            setFollowUpQuestion(neutralFollowUpQuestion);
        } else {
            setFollowUpQuestion(promoterFollowUpQuestion);
        }
    }, [score]);

    /* Defines the modal's placement after it mounts, used for the entrance transition */
    (0, _react.useEffect)(function () {
        if (contentRef) {
            contentRef.style.opacity = '100%';
            contentRef.style.top = '120px';
        }
    }, [contentRef]);

    /* Delays modal exit to allow for transition styles */
    var handleCloseRequest = function handleCloseRequest() {
        if (contentRef) {
            contentRef.style.opacity = '0';
            contentRef.style.top = '0';
        }

        setTimeout(function () {
            setVisible(false);
        }, 200);
    };

    var handleScoreSelected = function handleScoreSelected(selectedScore) {
        onScoreClick(score, mainQuestion);
        setScore(selectedScore);
        setShowFollowUp(true);
    };

    var handleCommentSubmit = function handleCommentSubmit(e) {
        e.preventDefault();

        onCommentSubmit(comment, followUpQuestion);
        handleCloseRequest();
    };

    return _react2.default.createElement(
        _reactModal2.default,
        {
            id: 'nps-modal',
            isOpen: visible,
            className: 'nps-modal__content ' + modalClassName,
            contentRef: function contentRef(node) {
                return setContentRef(node);
            },
            onRequestClose: handleCloseRequest,
            overlayClassName: 'nps-modal__overlay ' + overlayClassName
        },
        _react2.default.createElement(
            'button',
            {
                className: 'close-button',
                onClick: handleCloseRequest
            },
            '\xD7'
        ),
        !!header && _react2.default.createElement(
            'h2',
            { className: [modalClassPrefix, 'modal-header'].join('-') },
            header
        ),
        _react2.default.createElement(
            'div',
            { className: [modalClassPrefix, 'modal-body'].join('-') },
            showFollowUp ? _react2.default.createElement(
                'form',
                { className: 'follow-up-container', onSubmit: handleCommentSubmit },
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'comment-input', className: 'question-prompt' },
                    followUpQuestion
                ),
                _react2.default.createElement('textarea', {
                    className: 'comment-input',
                    id: 'comment-input',
                    onChange: function onChange(_ref) {
                        var target = _ref.target;
                        return setComment(target.value);
                    },
                    rows: '3',
                    value: comment
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'form-actions' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'button-submit',
                            type: 'submit'
                        },
                        'Submit'
                    )
                )
            ) : _react2.default.createElement(
                'div',
                {
                    className: 'score-selector-container',
                    onMouseLeave: function onMouseLeave() {
                        return setScore(undefined);
                    }
                },
                _react2.default.createElement(
                    'p',
                    { className: 'question-prompt' },
                    mainQuestion
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'scroll-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'score-selector' },
                        _react2.default.createElement(
                            'div',
                            { className: 'score-options' },
                            scoreRange.map(function (scoreOption) {
                                return _react2.default.createElement(
                                    'button',
                                    {
                                        key: scoreOption,
                                        className: 'score-selection ' + (scoreOption <= score ? 'score-selection__active' : ''),
                                        onMouseEnter: function onMouseEnter() {
                                            return setScore(scoreOption);
                                        },
                                        onClick: function onClick() {
                                            return handleScoreSelected(score);
                                        }
                                    },
                                    scoreOption
                                );
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'score-labels' },
                            _react2.default.createElement(
                                'p',
                                { className: 'score-label score-label__min' },
                                minScoreBlurb
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'score-label score-label__max' },
                                maxScoreBlurb
                            )
                        )
                    )
                )
            )
        )
    );
};

NPSModal.propTypes = {
    header: _propTypes2.default.string,
    modalClassName: _propTypes2.default.string,
    modalClassPrefix: _propTypes2.default.string,
    overlayClassName: _propTypes2.default.string,
    mainQuestion: _propTypes2.default.string.isRequired,
    promoterFollowUpQuestion: _propTypes2.default.string.isRequired,
    neutralFollowUpQuestion: _propTypes2.default.string.isRequired,
    detractorFollowUpQuestion: _propTypes2.default.string.isRequired,

    maxScore: _propTypes2.default.number.isRequired,
    detractorUpperBound: _propTypes2.default.number.isRequired,
    promoterLowerBound: _propTypes2.default.number.isRequired,
    minScoreBlurb: _propTypes2.default.string,
    maxScoreBlurb: _propTypes2.default.string,

    onScoreClick: _propTypes2.default.func.isRequired,
    onCommentSubmit: _propTypes2.default.func.isRequired
};

NPSModal.defaultProps = {
    header: '',
    maxScoreBlurb: 'Very likely',
    minScoreBlurb: 'Not likely',
    modalClassName: 'nps-modal',
    modalClassPrefix: '',
    overlayClassName: ''
};

exports.default = NPSModal;